import { css } from '@emotion/react'
import { Text, Theme, useTheme, VFlow } from 'bold-ui'
import { CheckboxField } from 'components/form'
import { usePecField } from 'components/form/core/hooks/useField'
import { RequiredLabel } from 'components/form/core/RequiredLabel/RequiredLabel'
import { TipoParticipacaoAtendimentoSelectField } from 'components/form/field/select/TipoParticipacaoAtendimentoSelectField'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { FinalizacaoAtendimentoFormModel } from '../FinalizacaoAtendimentoForm'
import { ObrigatoriedadesParticipacao } from '../util'

export interface ParticipacaoCidadaoFieldGroupProps {
  name: MetaPath<FinalizacaoAtendimentoFormModel>
  obrigatoriedadesParticipacao: ObrigatoriedadesParticipacao
}
// TODO @RNG - Criar um componente genérico utilizando <fieldset> e <legend> (#18472)
export function ParticipacaoCidadaoFieldGroup(props: Readonly<ParticipacaoCidadaoFieldGroupProps>) {
  const {
    name,
    obrigatoriedadesParticipacao: { isParticipacaoAmbos, isParticipacaoCidadao },
  } = props
  const {
    input: { value: cidadaoPresente },
  } = usePecField({ name: name.cidadaoPresente.absolutePath() })

  const theme = useTheme()
  const styles = createStyles(theme)

  const isParticipacaoCidadaoObrigatoria = isParticipacaoCidadao || isParticipacaoAmbos

  const {
    mutators: { changeValue },
  } = useForm()

  const isParticipacaoCidadaoObrigatoriaAnterior = useRef(isParticipacaoCidadaoObrigatoria)
  useEffect(() => {
    if (isParticipacaoCidadaoObrigatoriaAnterior.current !== isParticipacaoCidadaoObrigatoria) {
      isParticipacaoCidadaoObrigatoriaAnterior.current = isParticipacaoCidadaoObrigatoria

      if (isParticipacaoCidadaoObrigatoria) {
        changeValue(name.tipoParticipacaoCidadao, null)
      }
    }
  }, [changeValue, isParticipacaoCidadaoObrigatoria, name.tipoParticipacaoCidadao])

  const label = 'Cidadão participou do atendimento'

  return (
    <VFlow vSpacing={0.5} style={styles.container}>
      <CheckboxField
        name={name.cidadaoPresente}
        label={isParticipacaoCidadaoObrigatoria ? <RequiredLabel label={label} /> : <Text>{label}</Text>}
        style={styles.title}
      />
      <TipoParticipacaoAtendimentoSelectField
        label='Forma de participação'
        name={name.tipoParticipacaoCidadao}
        disabled={!cidadaoPresente}
        required={isParticipacaoCidadaoObrigatoria && !!cidadaoPresente}
      />
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    position: relative;
    margin-top: 0.5rem;
    padding: 1rem;
    border: 1px solid ${theme.pallete.gray.c80};
  `,
  title: css`
    font-weight: bold;
    position: absolute;
    top: -0.75rem;
    margin-left: -0.75rem;
    padding: 0 0.5rem;
    background-color: ${theme.pallete.surface.main};
  `,
})
